export type ValidatorResult = string | true;
export type Validator<T> = (obj: T) => ValidatorResult;
export type ValidationResult = string[];

export function validate<T>(validations: Array<Validator<T>>, obj: T): ValidationResult {
    return validations
        .map(validation => validation(obj))
        .filter((validationResult: string | true) => validationResult !== true) as ValidationResult;
}
